import React from "react";
import { Server, ShieldCheck, KeyRound, Link2, Clock, Lock } from "lucide-react";
import { useLang } from "../../context/LanguageContext";

export default function AdminBunny() {
  const { t } = useLang();

  const features = [
    {
      icon: KeyRound,
      title: "Advanced Token Authentication",
      desc: "HMAC-SHA256 signed URLs. The security key lives only on the server, never in the browser.",
    },
    {
      icon: Clock,
      title: "Temporary URLs",
      desc: "Each playback generates a short-lived URL that stops working after its TTL.",
    },
    {
      icon: Lock,
      title: "Anti-hotlinking protection",
      desc: "The origin stays private; only your backend can issue media access credentials.",
    },
    {
      icon: Link2,
      title: "Assets by logical ID",
      desc: "The CMS stores the Bunny asset ID / path and generates the playback URL on demand.",
    },
  ];

  return (
    <div className="animate-float-up">
      <h1 className="font-display text-3xl font-semibold tracking-tight mb-1">{t("admin_bunny")}</h1>
      <p className="text-sm text-muted-foreground mb-8">
        {"Secure delivery configuration with Bunny CDN"}
      </p>

      <div className="rounded-2xl border border-brand-500/25 bg-gradient-to-br from-secondary to-card p-6 mb-8">
        <div className="flex items-start gap-4">
          <div className="w-12 h-12 rounded-xl bg-brand-500/15 border border-brand-500/30 flex items-center justify-center shrink-0">
            <Server className="w-6 h-6 text-brand-400" />
          </div>
          <div>
            <h2 className="font-semibold text-lg">Bunny CDN</h2>
            <p className="text-sm text-muted-foreground mt-1 max-w-2xl leading-relaxed">
              {"Real signed streaming and storage integration will be connected in Phase 2 (backend). Your API credentials are already stored securely for that step."}
            </p>
            <div className="flex items-center gap-2 mt-3 text-xs text-emerald-400 font-medium">
              <ShieldCheck className="w-4 h-4" /> {"Credentials stored · ready for Phase 2"}
            </div>
          </div>
        </div>
      </div>

      <div className="grid sm:grid-cols-2 gap-4">
        {features.map((f) => (
          <div key={f.title} className="rounded-2xl border border-border bg-card/50 p-5">
            <div className="w-10 h-10 rounded-xl bg-secondary flex items-center justify-center mb-4">
              <f.icon className="w-5 h-5 text-brand-400" />
            </div>
            <h3 className="font-semibold">{f.title}</h3>
            <p className="text-sm text-muted-foreground mt-1.5 leading-relaxed">{f.desc}</p>
          </div>
        ))}
      </div>
    </div>
  );
}
